module.exports = __webpack_public_path__ + "assets/age-slider.png";


//////////////////
// WEBPACK FOOTER
// ./images/ai-preview/age-slider.png
// module id = 704
// module chunks = 0